import { c as _c } from "react/compiler-runtime";
import { cn } from "@/shared/lib/utils";
import type { HomeHelpSectionCardContent, HomeHelpSectionContent, HomeHelpSectionRowContent } from "@/features/home/types/home-page-content";
interface HomeHelpSectionProps {
  content: HomeHelpSectionContent;
}
interface HomeHelpMarqueeRowProps {
  row: HomeHelpSectionRowContent;
}
interface HomeHelpCardProps {
  card: HomeHelpSectionCardContent;
}
function HomeHelpCard(t0) {
  const $ = _c(7);
  const {
    card
  } = t0;
  if (card.variant === "image") {
    const t1 = `url(${card.imageUrl})`;
    let t2;
    if ($[0] !== t1) {
      t2 = {
        backgroundImage: t1,
        backgroundPosition: "center",
        backgroundSize: "cover"
      };
      $[0] = t1;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="absolute inset-0 bg-[linear-gradient(180deg,transparent_18%,rgba(44,28,24,0.18)_100%)]" />;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== t2) {
      t4 = <article className="relative h-[12rem] w-[clamp(16rem,23vw,24rem)] shrink-0 overflow-hidden rounded-[1.45rem] bg-muted" style={t2}>{t3}</article>;
      $[3] = t2;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  let t1;
  if ($[5] !== card.title) {
    t1 = <article className="flex h-[12rem] w-[clamp(16rem,23vw,24rem)] shrink-0 items-center justify-center rounded-[1.45rem] bg-card px-8 text-center text-card-foreground"><h3 className="font-heading text-2xl leading-[0.94] font-normal tracking-[-0.05em] text-balance">{card.title}</h3></article>;
    $[5] = card.title;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
function HomeHelpMarqueeRow(t0) {
  const $ = _c(12);
  const {
    row
  } = t0;
  let t1;
  if ($[0] !== row.cards) {
    t1 = [...row.cards, ...row.cards, ...row.cards];
    $[0] = row.cards;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const trackCards = t1;
  const animationName = row.direction === "left" ? "home-marquee-left" : "home-marquee-right";
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("pause-on-hover flex w-max gap-4 md:gap-5");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${row.durationSeconds}s`;
  let t4;
  if ($[3] !== animationName || $[4] !== t3) {
    t4 = {
      animationDuration: t3,
      animationIterationCount: "infinite",
      animationName,
      animationTimingFunction: "linear",
      willChange: "transform"
    };
    $[3] = animationName;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== row.id || $[7] !== trackCards) {
    t5 = trackCards.map((card, index) => <HomeHelpCard card={card} key={`${row.id}-${card.id}-${index}`} />);
    $[6] = row.id;
    $[7] = trackCards;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="overflow-hidden"><div className={t2} style={t4}>{t5}</div></div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
export function HomeHelpSection(t0) {
  const $ = _c(12);
  const {
    content
  } = t0;
  const t1 = content.id;
  let t2;
  if ($[0] !== content.title) {
    t2 = <div className="px-6 sm:px-10 lg:px-12"><h2 className="text-center font-heading font-serif text-4xl tracking-tight text-foreground md:text-6xl">{content.title}</h2></div>;
    $[0] = content.title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== content.rows) {
    t3 = content.rows.map(_temp);
    $[2] = content.rows;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex flex-col gap-4 md:gap-5">{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <div className="mx-auto flex w-full max-w-full flex-col gap-8 px-0 md:gap-16">{t2}{t4}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== content.id || $[10] !== t5) {
    t6 = <section id={t1} className="relative z-40 overflow-hidden bg-background py-16 text-foreground md:py-32">{t5}</section>;
    $[9] = content.id;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp(row) {
  return <HomeHelpMarqueeRow key={row.id} row={row} />;
}